// https://endertech.com/blog/using-reacts-context-api-for-global-state-management
import React, { createContext, useReducer } from 'react';
import AppReducer from './AppReducer';

const initialState = {
  activeProfile: {},
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  //   console.log('GlobalProvider');

  // Actions for changing state
  function clearProfileData() {
    dispatch({
      type: 'CLEAR_ITEMS',
      payload: {},
    });
  }
  function setProfileData(profile) {
    dispatch({
      type: 'SET_PROFILE',
      payload: profile,
    });
  }

  return (
    <GlobalContext.Provider
      value={{
        activeProfile: state.activeProfile,
        clearProfileData,
        setProfileData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
